import { createFileRoute } from "@tanstack/react-router";
import Page from "@project/admin/pages/admissions/admission-recommendation";

export const Route = createFileRoute(
  "/admin/_admissions/admission-recommendation"
)({
  component: Page,
});
